import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import ROUTES from 'constants/routes';
import { formatFilterToObject, formatSortByToObject } from 'app/api/helpers';
import { hashFiltersToURL } from 'features/sagaHelpers';
import { getArrangedFilters } from 'features/helpers';
import { fetchInventoryAtsReport } from 'services/feeds/actions';
import { ACTIONS } from '../constants';
import {
  loadInventoryAts,
  loadInventoryAtsSuccess,
  loadInventoryAtsError,
  setFilters,
  loadFeed,
} from '../actions';
import {
  getSettingsItemsPerPage,
  getSettingsSorting,
  getLastPage,
  getFilters,
  selectIncludeSpecialZones,
  selectShipTypes,
} from '../selectors';


export function* getInventoryATSParams(otherParams = {}) {
  const itemsPerPage = yield select(getSettingsItemsPerPage);
  const includeSpecialZones=yield(select(selectIncludeSpecialZones))
  const { columnId, direction } = yield select(getSettingsSorting);
  const page = yield select(getLastPage);
  const sortBy = yield call(formatSortByToObject, columnId, direction);
  const filters = yield select(getFilters);
  const filter = yield call(formatFilterToObject, filters);
  // const allShipTypes = ['p', 's', 'd', 'f', 'x', 'm'];
  const defaultShipType = ['p'];
  const shipTypes = yield select(selectShipTypes);
  const selectedShipTypes = shipTypes.length === 0 ? defaultShipType : shipTypes;
  
  const params = {
    itemsPerPage,
    page,
    sortBy,
    filter,
    ship_type:selectedShipTypes,
    qty_includes_special: includeSpecialZones ? 1 : 0,
    ...otherParams,
  };

  return params;
}

function* requestInventoryFeed(otherParams = {}) {
  const filters = yield select(getFilters);
  yield call(hashFiltersToURL, filters, ROUTES.REPORTS.INVENTORY_ATS_REPORT);
  const params = yield call(getInventoryATSParams, otherParams);
  yield put(loadFeed());
  yield put(fetchInventoryAtsReport(params, loadInventoryAtsSuccess, loadInventoryAtsError));
}


export function* loadInventoryAtsWatcher() {
  // yield put(setIsFetchingFeed(true));
  yield call(requestInventoryFeed);
}

function* loadInventoryAtsErrorWatcher({ errorMessage }) {
  yield call([toast, toast.error], errorMessage);
}

function* arrangeFiltersWatcher({ destination, source }) {
  const filters = yield select(getFilters);
  const updatedFilters = yield call(getArrangedFilters, destination, source, filters);
  yield put(setFilters(updatedFilters));
  if (JSON.stringify(filters) !== JSON.stringify(updatedFilters)) {
    yield put(loadInventoryAts());
  }
}

export default function* loadInventoryAtsSagas() {
  yield all([
    takeEvery(
      [
        ACTIONS.LOAD_INVENTORY_ATS,
        ACTIONS.REFRESH_INVENTORY_FEED,
        ACTIONS.SORT_INVENTORY_FEED,
        ACTIONS.SET_FILTER_OPERAND,
        ACTIONS.UNSET_FILTER_OPERAND,
        ACTIONS.CLEAR_FILTERS,
        ACTIONS.SET_ITEMS_PER_PAGE,
        ACTIONS.GO_TO_PAGE,
        ACTIONS.TOGGLE_INCLUDE_SPECIAL_ZONES,
        ACTIONS.ADD_SHIP_TYPE,
        ACTIONS.REMOVE_SHIP_TYPE
      ],
      loadInventoryAtsWatcher,
    ),
    takeEvery(ACTIONS.LOAD_INVENTORY_ATS_ERROR, loadInventoryAtsErrorWatcher),
    takeEvery(ACTIONS.ARRANGE_FILTERS, arrangeFiltersWatcher),
  ]);
}
